import useMessage from '@/natives/libs/hooks/useMessage';
import getErrorTip from './getErrorTip';

let preErrorCode;
const handleErrorAndTip = (i18n) => (errorCode, response) => {
  if (preErrorCode === errorCode) {
    return;
  }
  preErrorCode = errorCode;
  let title = i18n.t('error');
  let type = 'error';

  return useMessage({
    title,
    type,
    message: getErrorTip(i18n)(errorCode, response)
  })
    .then(() => {
      preErrorCode = null;
    })
    .catch(() => {
      preErrorCode = null;
    });
};

export default handleErrorAndTip;
